import React, { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { sw } from "utils"
import { Button, Modal } from "components"
import classes from "./index.module.scss"

const NewServiceWorkerModal = () => {
  const [t, i18n] = useTranslation()

  const [sending, setSending] = useState(false)
  const [openNewServiceWorkerModal, setOpenNewServiceWorkerModal] = useState(false)

  const handleInstallNewServiceWorker = () => {
    setSending(true)

    sw.skipWaiting()
  }

  useEffect(() => {
    document.addEventListener("new-service-worker", () => {
      setOpenNewServiceWorkerModal(true)
    })
  }, [])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Modal
      show={openNewServiceWorkerModal}
    >
      <div className={classes["container"]}>
        <div className={classes["subTitle"]}>
          {t("ورژن_اپ_قدیمی_است")}
        </div>
        <div className={classes["title"]}>
          {t("بروز_رسانی_اجباری")}
        </div>
        <div className={classes["text"]}>
          {t("برخی_از_قابلیتهای_جدید_در_نسخه_فعلی_قابل_دسترس_نمی_باشد_لطفا_بروزرسانی_کنید")}
        </div>

        <div className={classes["footer"]}>
          <Button
            color="success"
            loading={sending}
            onClick={handleInstallNewServiceWorker}
            className={clsx(classes["button"], isLtr && classes["button-ltr"])}
          >
            {t("بروزرسانی")}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default NewServiceWorkerModal